import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors"; // Poolcorp Custom Code
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
import MainNavigationItem from "@insite/content-library/Components/MainNavigationItem";
// import NavigationDrawer from "@insite/content-library/Components/NavigationDrawer"; // Poolcorp Custom Code
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
// import { IconProps } from "@insite/mobius/Icon"; // Poolcorp Custom Code
import Search from "@insite/mobius/Icons/Search";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
// import { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover"; // Poolcorp Custom Code
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as cssLinter from "css";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import Zone from "@insite/client-framework/Components/Zone";
import { getCurrentUserIsGuest, getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { IconProps, IconWrapper } from "@insite/mobius/Icon";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import { OverflowWrapperProps, PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import getProp from "@insite/mobius/utilities/getProp";
import NavigationDrawer from "@store/Overrides/Components/NavigationDrawer";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { contentSpacingStyles, focusStyles, linkStyles, siteWidthStyles, transitionHoverStyles } from "@store/theme/common/mixins";
import { menuMobileButtonProps } from "@store/theme/common/props/menu";
import { COMMON, MENU, TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import isTheme from "@store/utilities/isTheme";
/* Poolcorp Custom Code */

const enum fields {
    links = "links",
    // Poolcorp Custom Code - remove quickOrder props
    openParentPages = "openParentPages",
    customCSS = "customCSS",
    hideLanguageSelector = "hideLanguageSelector", // Poolcorp custom code
    hideCurrencySwitcher = "hideCurrencySwitcher", // Poolcorp custom code
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        // Poolcorp Custom Code - remove quickOrder props
        [fields.openParentPages]: boolean;
        [fields.customCSS]: string;
        [fields.hideLanguageSelector]: boolean; // Poolcorp custom code
        [fields.hideCurrencySwitcher]: boolean; // Poolcorp custom code
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    isCompactHeaderMainNavigation: boolean;
    compactHeaderMainNavigationCustomCSS?: string;
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        // Poolcorp Custom Code
        maxChildren: number;
        visibleForSignedInUsersOnly: boolean;
    };
}

export interface MappedLink {
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu";
    children?: MappedLink[];
    // Poolcorp Custom Code
    maxChildren?: number;
    visibleForSignedInUsersOnly?: boolean;
    properties?: { [key: string]: string; };
    isViewAllLink?: boolean;
}

const mapStateToProps = (state: StoreApplicationState, ownProps: OwnProps) => { // Poolcorp Custom Code
    const {
        fields: { links = [] },
    } = ownProps;
    const mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};

    for (const link of links) {
        const {
            fields: {
                linkType,
                destination,
                openInNewWindow,
                overrideTitle,
                numberOfColumns,
                maxDepth,
                title,
                // Poolcorp Custom Code
                maxChildren,
                visibleForSignedInUsersOnly,
            },
        } = link;
        const { type, value } = destination;

        const depthToLoad = linkType === "MegaMenu" ? 3 : maxDepth;

        let mappedLink: MappedLink | undefined;

        if (type === "Url") {
            mappedLink = {
                url: value,
                title,
            };
        } else if (type === "Page") {
            const readonlyPageLink = getPageLinkByNodeId(state, value);
            if (readonlyPageLink) {
                mappedLink = { ...readonlyPageLink };
                if (overrideTitle) {
                    mappedLink.title = overrideTitle;
                }
            }
        } else if (type === "Category") {
            mappedLink = setupCategoryLink(
                state,
                value,
                categoryIdsToLoad,
                depthToLoad,
                overrideTitle,
                state.data.categories.categoryIdsCalled,
            );
        }

        if (!mappedLink) {
            continue;
        }

        mappedLink.openInNewWindow = openInNewWindow;
        mappedLink.numberOfColumns = numberOfColumns;
        mappedLink.maxDepth = maxDepth;

        /* Poolcorp Custom Code */
        mappedLink.maxChildren = maxChildren;
        mappedLink.visibleForSignedInUsersOnly = visibleForSignedInUsersOnly;
        /* Poolcorp Custom Code */

        if (linkType === "MegaMenu" || linkType === "CascadingMenu") {
            mappedLink.childrenType = linkType;
        }

        mappedLinks.push(mappedLink);
    }

    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const orderSettings = getSettingsCollection(state).orderSettings;
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const isVmiAdmin = session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1;
    const isVmiUser = session.userRoles?.toLowerCase().indexOf("vmi_user") !== -1;

    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" && orderSettings.vmiEnabled && isAuthenticated && (isVmiAdmin || isVmiUser),
        displayModeSwitch: isAuthenticated && orderSettings.vmiEnabled && (isVmiAdmin || isVmiUser),
        currentMode,
        vmiPageLinks: isVmiAdmin
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiUsersPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : isVmiUser
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : [],
        // Poolcorp Custom Code
        rememberMe: state.context.session.rememberMe,
        isSignedIn: state.context.session.userName && !getCurrentUserIsGuest(state),
    };
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
            };
        }

        loadSubCategories(mappedLink, subCategoryIds, 1, maxDepth, state);
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }

    /* Poolcorp Custom Code */
    if (currentDepth === 1) {
        const parentLink: MappedLink = {
            url: mappedLink.url,
            title: `${translate("View All")} ${mappedLink.title}`,
            properties: mappedLink.properties,
            isViewAllLink: true,
        };

        mappedLink.children.push(parentLink);
    }
    /* Poolcorp Custom Code */

    for (const subCategoryId of subCategoryIds) {
        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            properties: subCategory.properties, // Poolcorp Custom Code
            children: [],
        };

        /* Poolcorp Custom Code */
        if (childLink.properties?.isShopAll !== "true") {
            mappedLink.children.push(childLink);
        }
        /* Poolcorp Custom Code */

        loadSubCategories(childLink, subCategory.subCategoryIds, currentDepth + 1, maxDepth, state);
    }
};

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
    // Poolcorp Custom Code
    innerContainer?: InjectableCss;
    mobileLogoWrapper?: InjectableCss;
    popoverWrapper?: OverflowWrapperProps;
    megaMenuSeeMoreLink?: LinkPresentationProps;
    megaMenuViewAllLink?: LinkPresentationProps;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 50,
    container: {
        css: css`
            background-color: ${getColor("header.mainNavBackground")};
            border-top: 1px solid ${getColor("header.mainNavBorder")};
            border-bottom: 1px solid ${getColor("header.mainNavBorder")};
            height: 3.75em;
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: [15, null, null, null, 16], properties: ["font-size"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    innerContainer: {
        css: css`
            position: relative;
            ${siteWidthStyles()}
            display: flex;
            justify-content: center;
            width: 100%;
            height: 100%;
        `,
    },
    itemWrapper: {
        css: css`
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        { 
                            values: isTheme(props.theme, "horizon") 
                                ? ["-1px 0.25em", null, null, "-1px 0.5em", null] 
                                : ["-1px 0.5em", null, null, "-1px 1em", null], 
                            properties: ["margin"]
                        },
                    ],
                    mediaOptions.min,
                )}
            color: ${getColor("header.contrastMain")};
            border-color: transparent;

            &:first-child {
                ${({ theme }) => {
                    if (isTheme(theme, "horizon")) {
                        return css`color: ${getColor("white")};`;
                    }

                    return css`color: ${getColor("header.mainNavText")};`;
                }}

                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        `,
    },
    quickOrderItemWrapper: {
        css: css`
            height: 100%;
            border-color: inherit;
        `,
    },
    cascadingMenu: {
        cssOverrides: {
            wrapper: css`
                height: 100%;
                border-color: inherit;
            `,
        },
    },
    megaMenuGridItem: {
        css: css<any>`
            display: block;

            li {
                ${contentSpacingStyles(null, "0.25em")}
            }
        `,
    },
    megaMenuHeading: {
        css: css`
            ${({ theme }) => {
                if (isTheme(theme, "horizon")) {
                    return css`
                        ${linkStyles("text", "secondary.main", true)};
                    `;
                }

                return css`
                    ${linkStyles("text", "header.mainNavText", false)};
                `;
            }}
            margin-bottom: 0.5em;
            font-weight: ${TYPOGRAPHY.weight.bold};
            line-height: 1.3;
        `,
    },
    megaMenuLink: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
        },
        css: css`
            ${({ theme }) => {
                if (isTheme(theme, "horizon")) {
                    return css`
                        ${linkStyles("text", "secondary.main", true)};
                    `;
                }

                return css`
                    ${linkStyles("text", "header.mainNavText", false)};
                `;
            }}
        `,
    },
    megaMenuSeeMoreLink: {
        color: "text.main",
        hoverStyle: {
            textDecoration: "underline",
        },
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    megaMenuViewAllLink: {
        css: css`
            ${linkStyles("text.link", "text.linkHover", false)}
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
        icon: {
            iconProps: {
                src: ChevronRight,
                size: 20,
                color: "inherit",
                css: css`
                    margin-left: 0.1em;
                    padding-top: 0.1em;
                `,
            },
            position: "right",
        },
    },
    menuItem: {
        css: css`
            ${focusStyles()}
            height: 100%;
            color: ${getColor("header.mainNavText")};
            ${({ theme }) => {
                if (isTheme(theme, "horizon")) {
                    return css`
                        padding: 0 0.5em;
                        ${transitionHoverStyles("color", "background-color")}
                    `;
                }

                return css`
                    border-width: 2px 0;
                    border-style: solid;
                    border-top-color: transparent;
                    border-bottom-color: transparent;
                    ${transitionHoverStyles("color", "border-bottom-color")}
                `;
            }}
            text-align: center;

            &:hover,
            &:active {
                ${({ theme }) => {
                    if (isTheme(theme, "horizon")) {
                        return css`
                            background-color: ${getColor("primary")};
                            color: ${getColor("secondary")};

                            ${IconWrapper} {
                                color: ${getColor("secondary")};
                            }
                        `;
                    }
    
                    return css`
                        color: ${getColor("header.mainNavText.light")};
                        border-bottom-color: ${getColor("primary")};
                    `;
                }}
            }
        `,
    },
    menuItemIcon: {
        size: undefined,
        css: css`
            position: relative;
            width: 0.7em;
            height: auto;
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        { values: ["0.1em 0 0 0.5em", null, null, "0.1em 0 0 1em", null], properties: ["margin"] },
                    ],
                    mediaOptions.min,
                )}
            color: ${getColor("header.mainNavText")};
            transition: inherit !important;

            svg {
                position: absolute;
                top: 50%;
                left: 50%;
                width: 170%;
                height: auto;
                transform: translate3d(-50%, -50%, 0);
            }
        `,
    },
    menuItemTypography: {
        css: css`
            display: flex;
            align-items: center;
            overflow: hidden;
            font-weight: ${getProp("theme.header.menuItemWeight")};
        `,
    },
    megaMenu: {
        transitionDuration: "short",
        contentBodyProps: {
            _height: "1200px",
            css: css<any>`
                box-shadow: ${getProp("theme.shadows.main")};
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            { values: COMMON.spacing.side, properties: ["right", "left"] },
                            { values: ["2em", null, null, null, "2.25em 2.5em"], properties: ["padding"] },
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
        wrapperProps: {
            css: css`
                height: 100%;
                border-color: inherit;
                position: static !important; /* Must be !important because it's not overridable  */
            `,
        },
    },
    mobileSearchButton: menuMobileButtonProps,
    mobileWrapper: {
        css: css`
            display: flex;
            align-items: center;
            height: 100%;
        `,
    },
    compactFlyoutMenu: {
        css: css`
            & button {
                background: transparent;
                border: none;
                &:hover {
                    background: rgba(0, 0, 0, 0.3);
                }

                svg {
                    color: ${props => resolveColor(props.theme.header.linkColor, props.theme)};
                }
            }
        `,
    },
    mobileSearchModal: {
        closeButtonProps: {
            css: css`
                padding: 0 10px;

                &:active,
                &:focus,
                &:disabled {
                    background-color: transparent;
                    border-color: transparent;
                }
            `,
        },
        cssOverrides: {
            scrim: css`
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            { values: ["block", null, null, "none"], properties: ["display"] },
                        ],
                        mediaOptions.min,
                    )}
            `,
            modalTitle: css`
                position: relative;
                padding: 0;
            `,
        },
    },
    mobileSearchWrapper: {
        css: css`
            height: 100%;
        `,
    },
    mobileMenuWrapper: {
        css: css`
            height: 100%;
        `,
    },
    mobileLogoWrapper: {
        css: css`
            height: 70%;
            flex-grow: 1;
            margin: 0 ${MENU.mobileButtonSpacing};

            > div {
                height: 100%;
            }
        `,
    },
    mobileSearchInputWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    mobileSearchInputStyles: {
        input: {
            iconProps: {
                css: css`
                    right: -13px;
                `,
            },
            cssOverrides: {
                formField: css`
                    width: 100%;
                `,
                inputSelect: css`
                    padding: 0.5em 2.75em 0.5em 1em;
                    background-color: ${getColor("common.accent")};
                    border: 2px solid transparent;

                    &:active,
                    &:focus {
                        padding: 0.5em 2.75em 0.5em 1em;
                    }

                    &::placeholder {
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        font-style: italic;
                    }
                `,
            },
        },
        popover: {
            wrapperProps: {
                css: css`
                    width: calc(100% - 45px);
                `,
            },
        },
        popoverWrapper: {
            as: "div",
            _height: "auto",
            css: css`
                display: inline-flex;
                justify-content: flex-end;
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: [null, "static !important", null, "relative"], properties: ["position"] }],
                        mediaOptions.max,
                    )}/* Must be !important because it's not overridable */
            `,
        },
        popoverContentBody: {
            as: "div",
            _height: "100%",
            css: css`
                box-shadow: none;
                max-height: none;
                top: 100%;
                right: 0;
                left: 0;
            `,
        },
        autocompleteWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
            `,
        },
        autocompleteColumnWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                width: 100%;
            `,
        },
        searchHistoryStyles: {
            wrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 0 30px 15px;
                `,
            },
        },
        autocompleteProductsStyles: {
            titleLink: {
                css: css`
                    width: 100%;
                `,
            },
            erpNumberText: {
                css: css`
                    width: 100%;
                    text-align: left;
                    margin: 5px 0 0 0;
                `,
            },
        },
    },
};

const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}

.currency-selector-wrapper {
}

.language-selector-wrapper {
}

.panel-menu {
}

.main-navigation-row {
}

.panel-section-wrapper {
}

.main-navigation-row-icon {
}

.user-row-text {
}

.punch-out-navigation-row-icon {
}

.punch-out-user-row-text {
}

.main-navigation-row-text {
}

.logo-links-row {
}

.logo-link-title {
}

.language-image {
}

.menu-row-icon {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.apply-button-grid-item {
}

.sign-out-row {
}

.sign-out-row-text {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}

.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;

export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLDivElement>();
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
        };
    }

    UNSAFE_componentWillMount(): void {
        this.loadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.loadCategoriesIfNeeded(true);
        }
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = 5; // categoryIdsToLoad[categoryId]; // Poolcorp custom code: for analytics purpose, we need to have all the categories path
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    this.props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "absolute", // Poolcorp Custom Code
        };
        /* Poolcorp Removed Code */

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: { openParentPages, customCSS, hideLanguageSelector, hideCurrencySwitcher }, // Poolcorp Custom Code - remove quickOrder props
            id,
            // Poolcorp Custom Code - remove allowQuickOrder props
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            showFlyoutPricingToggle,
            showFlyoutInventoryToggle,
            isCompactHeaderMainNavigation,
            compactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
            // Poolcorp Custom Code
            isSignedIn,
            rememberMe,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        // Poolcorp Custom Code - remove quickOrder
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeToNew(mainNavigationStyles, mainNavContextStyles);
        const userIsSignedIn = isSignedIn || rememberMe; // Poolcorp Custom Code

        if (isCompactHeaderFlyoutMenu) {
            const flyoutCustomCssWrapper = {
                css: css`
                    ${flyoutCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...flyoutCustomCssWrapper}>
                    <StyledWrapper className="flyout-menu-wrapper" {...styles.compactFlyoutMenu}>
                        <NavigationDrawer
                            links={links}
                            /* Poolcorp Custom Code - remove quickOrder props */
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            isCompactHeaderFlyout={true}
                            showFlyoutPricingToggle={showFlyoutPricingToggle}
                            showFlyoutInventoryToggle={showFlyoutInventoryToggle}
                            allowOpenParentLinks={openParentPages}
                        />
                    </StyledWrapper>
                </StyledWrapper>
            );
        }

        if (isCompactHeaderMainNavigation) {
            const mainNavigationCustomCSSWrapper = {
                css: css`
                    ${compactHeaderMainNavigationCustomCSS}
                `,
            };

            return (
                <StyledWrapper {...mainNavigationCustomCSSWrapper}>
                    {displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <Link
                                                className="vmi-page-link"
                                                key={link.id}
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id={link.id}
                                                href={link.url}
                                            >
                                                {link.title}
                                            </Link>
                                        ),
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                    {!displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            {links.map((link, index) => {
                                return (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <StyledWrapper className="item-wrapper" {...styles.itemWrapper} key={index}>
                                        <MainNavigationItem
                                            index={index}
                                            link={link}
                                            styles={styles}
                                            container={this.container}
                                            isOpen={index === selectedLinkIndex}
                                            displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                        />
                                    </StyledWrapper>
                                );
                            })}
                            {/* Poolcorp Custom Code - remove quickOrder */}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            );
        }

        const customCssWrapper = {
            css: css`
                ${customCSS}
            `,
        };

        return (
            <>
                {/* Poolcorp Custom Code */}
                <Hidden above="sm" className="mobile-wrapper" {...styles.mobileWrapper}>
                    <StyledWrapper className="mobile-menu-wrapper" {...styles.mobileMenuWrapper}>
                        <NavigationDrawer
                            links={links}
                            /* Poolcorp Custom Code - remove quickOrder props */
                            rootElementSelector=".mobile-menu-wrapper"
                            allowOpenParentLinks={openParentPages}
                            hideLanguageSelector={hideLanguageSelector} // Poolcorp Custom Code
                            hideCurrencySwitcher={hideCurrencySwitcher} // Poolcorp Custom Code
                        />
                    </StyledWrapper>
                    <StyledWrapper {...styles.mobileLogoWrapper} data-test-selector="LogoZoneMobile">
                        <Zone contentId={id} zoneName="MobileLogo"/>
                    </StyledWrapper>
                    <StyledWrapper className="mobile-search-wrapper" {...styles.mobileSearchWrapper}>
                        <Button
                            className="mobile-search-button"
                            {...styles.mobileSearchButton}
                            onClick={this.mobileSearchButtonClickHandler}
                        >
                        <ButtonIcon className="mobile-search-button-icon" src={Search} />
                            <VisuallyHidden>{translate("Search")}</VisuallyHidden>
                        </Button>
                    </StyledWrapper>
                </Hidden>
                <Hidden below="md">
                    {!displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper {...styles.innerContainer}> {/* Poolcorp Custom Code */}
                                {links.map((link, index) => {
                                    /* Poolcorp Custom Code */
                                    if (link.visibleForSignedInUsersOnly && !userIsSignedIn) {
                                        return null;
                                    }
                                    /* Poolcorp Custom Code */
                                    return (
                                        // eslint-disable-next-line react/no-array-index-key
                                        <StyledWrapper className="item-wrapper" {...styles.itemWrapper} key={index}>
                                            <MainNavigationItem
                                                index={index}
                                                link={link}
                                                styles={styles}
                                                container={this.container}
                                                isOpen={index === selectedLinkIndex}
                                                displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                            />
                                        </StyledWrapper>
                                    );
                                })}
                                {/* Poolcorp Removed - Quick Order */}
                            </StyledWrapper> {/* Poolcorp Custom Code */}
                        </StyledWrapper>
                    )}
                    {displayVmiNavigation && (
                        <StyledWrapper className="container" {...styles.container} ref={this.container}>
                            <StyledWrapper className="item-wrapper" {...styles.itemWrapper}>
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <Link
                                                className="vmi-page-link"
                                                key={link.id}
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                id={link.id}
                                                href={link.url}
                                            >
                                                {link.title}
                                            </Link>
                                        ),
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </Hidden>
                <Modal
                    className="mobile-search-modal"
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    headline={
                        <SearchInput
                            id={id}
                            inputRef={this.mobileSearchInput}
                            autocompletePositionFunction={this.getMobileSearchAutocompletePosition}
                            onBeforeGoToUrl={this.mobileSearchModalCloseHandler}
                            extendedStyles={styles.mobileSearchInputStyles}
                        />
                    }
                />
                {/* Poolcorp Custom Code */}
            </>
        );
    }
}

MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

// Poolcorp Custom Code - remove advancedTab const

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type, value } = item.fields.destination;
                    const { overrideTitle, title } = item.fields;
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === "Category") {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === "Url") {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linkType",
                        editorTemplate: "RadioButtonsField",
                        defaultValue: "Link",
                        isRequired: true,
                        options: [
                            {
                                displayName: "Link",
                                value: "Link",
                            },
                            {
                                displayName: "Mega Menu",
                                value: "MegaMenu",
                            },
                            {
                                displayName: "Cascading Menu",
                                value: "CascadingMenu",
                            },
                        ],
                    },
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                        allowUrls: item => item.fields.linkType === "Link",
                        showCategoryRoot: item => true,
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.destination.type !== "Url",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                        isVisible: item => item.fields.destination.type === "Url",
                    },
                    {
                        name: "numberOfColumns",
                        editorTemplate: "DropDownField",
                        defaultValue: 6,
                        options: [{ value: 2 }, { value: 3 }, { value: 4 }, { value: 6 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "maxDepth",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "CascadingMenu",
                    },
                    /* Poolcorp Custom Code */
                    {
                        name: "maxChildren",
                        editorTemplate: "IntegerField",
                        defaultValue: 12, // Poolcorp Custom Code
                        isRequired: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "visibleForSignedInUsersOnly",
                        editorTemplate: "CheckboxField",
                        displayName: "Visible for signed in/remembered users only",
                        defaultValue: false,
                    },
                    /* Poolcorp Custom Code */
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "Link",
                    },
                ],
                tab: basicTab,
            },
            // Poolcorp Custom Code - remove quickOrder props
            {
                name: fields.openParentPages,
                displayName: "Open Parent Pages",
                tooltip:
                    "When enabled, tapping on a text link in the flyout menu will directly open the linked webpage and require users to click the chevron to access child pages. If disabled, tapping any link in the flyout menu will navigate to a submenu of child pages.",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            // Poolcorp Custom Code - remove customCSS props
            /* Poolcorp Custom Code */
            {
                name: fields.hideLanguageSelector,
                displayName: "Hide Language Selector (mobile)",
                editorTemplate: "CheckboxField",
                tooltip: "Hide the Language Selector in the mobile drawer menu",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            {
                name: fields.hideCurrencySwitcher,
                displayName: "Hide Currency Switcher (mobile)",
                editorTemplate: "CheckboxField",
                tooltip: "Hide the Currency Switcher in the mobile drawer menu",
                defaultValue: false,
                fieldType: "General",
                tab: basicTab,
            },
            /* Poolcorp Custom Code */
        ],
    },
};

export default mainNavigation;
